<template>
     <div :class="['swiper pdfSlider h-full', {'fullView' : expandPdf}]">
            <div class="swiper-wrapper pdfWrapper"></div>

            <div class="swiper-button-prev">
                <church-icon icon="arrow-left" />
            </div>

            <div class="swiper-button-next">
                <church-icon icon="arrow-right" />
            </div>

            <div class="slideBarWrapper">
                <div class="pageIndicator">
                    {{ currentPage }}/{{ totalPage }}
                </div>
                <b-form-input
                    :number="true"
                    id="range-2"
                    @input="seekPage"
                    :value="currentPage"
                    type="range"
                    min="1"
                    :max="totalPage"
                    step="1"
                ></b-form-input>
                
                <a href="" @click.prevent="expandPdf = !expandPdf" class="ml-2">
                    <church-icon v-if="!expandPdf" icon="expand"/>
                    <church-icon v-if="expandPdf" icon="compress"/>
                </a>
            </div>
        </div>
</template>

<script>

/* Plugins */
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import _ from "lodash";


export default {
    name : "PDFViewer",
    props : {
        pdfUrl : {
            type : String,
            default : () => ""
        }
    },
    data() {
        return {
            currentPage: 1,
            pdfSlider  : {},
            expandPdf  : false
        }
    },
    computed: {
        /* Total page */
        totalPage() {
            return 9;
        },
    },
    methods : {
        /**
         * Slide to the page 
         * @param {Number} toIndex
         */
        seekPage(toIndex) {
            const indexNumber = toIndex - 1;
            this.pdfSlider?.slideTo(indexNumber, 500);
        },
        /* Init pdf */
        initPDF: _.debounce(function (url) {
            /* Prevent if no pdf  */
            if (!url) return;
            

            // Loaded via <script> tag, create shortcut to access PDF.js exports.
            const pdfjsLib = window["pdfjs-dist/build/pdf"];

            // The workerSrc property shall be specified.
            // pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.mjs';

            const pdfWrapper = document.querySelector(".pdfWrapper");

            // Asynchronous download of PDF
            const loadingTask = pdfjsLib.getDocument(url);
            loadingTask.promise.then(
                (pdf) => {
                    console.log(
                        pdfWrapper,
                        "PDF loaded",
                        pdf._pdfInfo.numPages
                    );

                    /* Loop and render each page */

                    for (
                        let index = 1;
                        index <= pdf._pdfInfo.numPages;
                        index++
                    ) {
                        const pageNumber = index;
                        pdf.getPage(pageNumber).then((page) => {
                            console.log("Page loaded");

                            const scale = 5;
                            const viewport = page.getViewport({ scale: scale });

                            // Prepare canvas using PDF page dimensions
                            const canvas = document.createElement("canvas");

                            const sliderItem = document.createElement("div");
                            sliderItem.className = "swiper-slide";

                            sliderItem.appendChild(canvas);
                            pdfWrapper.appendChild(sliderItem);

                            console.log("canvas", canvas);

                            const context = canvas.getContext("2d");
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;

                            // Render PDF page into canvas context
                            const renderContext = {
                                canvasContext: context,
                                viewport: viewport,
                            };
                            const renderTask = page.render(renderContext);
                            renderTask.promise.then(() => {
                                console.log(
                                    "Page rendered",
                                    pageNumber == pdf._pdfInfo.numPages
                                );

                                if (pageNumber == pdf._pdfInfo.numPages) {
                                    this.pdfSlider = new Swiper(".pdfSlider", {
                                        modules: [Navigation],
                                        navigation: {
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        },
                                    });

                                    this.pdfSlider.on(
                                        "activeIndexChange",
                                        (swiper) => {
                                            console.log("index change", swiper);
                                            this.currentPage =
                                                swiper?.activeIndex + 1;
                                        }
                                    );
                                }
                            });
                        });
                    }

                    // Fetch the first page
                },
                (reason) => {
                    // PDF loading error
                    console.error(reason);
                }
            );
        }, 200),
    },
    mounted() {
        /**
         * Create new intance for pdf
         */
        this.initPDF(this.pdfUrl);
    }
}
</script>


<style lang="scss">
@import "@/scss/partials/_colors.scss";

.pdfSlider {

    .slideBarWrapper {
        position: absolute;
        bottom: 30px;
        left: 0;
        right: 0;
        padding-inline: 30px;
        z-index: 10;
        display: flex;
        align-items: center;

        .pageIndicator {
            margin-right: 15px;
        }
        .custom-range {
            &::-webkit-slider-thumb {
                -webkit-appearance: none;
                background-color: $gray;
            }
        }
    }

    .swiper-button {
        &-prev,
        &-next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background-color: $gray;
            width: 40px;
            height: 40px;
            border-radius: 100%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
        }

        &-prev {
            left: 30px;
        }

        &-next {
            right: 30px;
        }

        &-disabled {
            opacity: 0.5;
        }
    }

    canvas {
        width     : 100%;
        height    : 100%;
        object-fit: contain;
    }

    .swiper {
        &-slide {
            height: calc(100vh - 128px);
        }

        &.fullView {
            position        : fixed;
            width           : 100%;
            height          : 100%;
            top             : 0;
            bottom          : 0;
            left            : 0;
            right           : 0;
            background-color: #fff;
            z-index         : 100;

            .swiper-button {
                &-prev, &-next {
                    display: none;
                }
            }

            &:focus {
                .swiper-button {
                    &-prev, &-next {
                        display: flex;
                    }
                }
            }
        }
    }

    .insert-page {
        margin-top      : 15px;
        display         : flex;
        flex-direction  : column;
        background-color: transparent;
        transition      : all 0.2s ease-in-out;

        &-title {
            cursor: pointer;
        }

        svg {
            display: none;
        }

        display: inline-block;

        &.show {
            background-color: $gray2;
            padding-block   : 15px;
            margin-bottom   : 15px;
            display         : block;
            margin-inline   : -30px;
            padding-inline  : 30px;

            .insert-page {
              &.show {
                background-color: darken( $gray2, 10%);

                .insert-page {
                  &.show {
                    background-color: darken( $gray2, 15%);

                    .insert-page {
                        &.show {
                          background-color: darken( $gray2, 20%);

                          .insert-page {
                              &.show {
                                background-color: darken( $gray2, 25%);
                              }
                            }
                        }
                      }
                  }
                }
              }
            }

            svg {
                display: block;
            }

            .subContentBody {
                margin-bottom: 10px;
                max-height: 100vh;
            }
        }

        &-title {
            color      : $blue;
            font-size  : 15px;
            display    : flex;
            align-items: center;

            svg {
                margin-left: auto;
                color: $black;
            }
        }
    }
}


</style>